module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Pixel.2da4dad2.png";